import type { ExternalTableSchema } from '@packages/table-builder';

export const sharePoolTable: ExternalTableSchema = {
  metadata: {
    title: 'Share Pool Management',
    entity: 'Share Pool',
    description: 'Current list of share pools.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/pool/pool-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'date',
      sortable: true,
      width: 200,
    },
    { field: 'poolName', header: 'Pool Name', type: 'text', sortable: true, width: 300 },
    {
      field: 'numberOfSharesAuthorised',
      header: 'Number Of Shares Authorised',
      type: 'text',
      sortable: true,
      width: 300,
    },
    {
      field: 'numberOfSharesAvailable',
      header: 'Number Of Shares Available',
      type: 'text',
      sortable: true,
      width: 300,
    },
    {
      field: 'numberOfSharesUnAvailable',
      header: 'Number Of Shares UnAvailable',
      type: 'text',
      sortable: true,
      width: 300,
    },
    {
      field: 'eligibleShareClass',
      header: 'Eligible Share Class',
      type: 'text',
      sortable: true,
      width: 300,
    },
    {
      field: 'stockClassName',
      header: 'Stock Class',
      type: 'text',
      sortable: true,
      width: 300,
    },
    {
      field: 'hasExternalPoolRefrence',
      header: 'Has External Pool',
      type: 'badge',
      width: 300,
      badge: {
        statusMap: { true: 'success', false: 'info' },
        defaultVariant: 'info',
      },
      conditionalValues: { true: 'ENABLED', false: 'DISABLED' },
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_SHARE_POOL', label: 'View' },
      { id: 'EDIT_SHARE_POOL', label: 'Edit' },
      { id: 'DELETE_SHARE_POOL', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_SHARE_POOL',
        label: 'Add Share Pool',
        icon: 'add_circle',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'Share Pool',
      resizable: true,
      reorderable: true,
    },
  },
};
